import * as React from "react";
import { DeviceData } from "../models/DeviceData";

interface Props {
  x: string;
  y: string;
  fontSize: string;
  device1?: DeviceData;
  device2?: DeviceData;
}

const displayName = (device1: DeviceData, device2: DeviceData) => {
  if (device1?.ptProtectiveFunction && device2?.ptProtectiveFunction) {
    return `${device1.ptProtectiveFunction.tageName}, ${device2.ptProtectiveFunction.tageName}`;
  }
  else if (device1?.ptProtectiveFunction) {
    return device1.ptProtectiveFunction.tageName;
  }
  else if (device2?.ptProtectiveFunction) {
    return device2.ptProtectiveFunction.tageName;
  }
  else {
    return "";
  }
}

const ManualDeviceInfo = (props: Props) => {
    let tagName = "";
    let pfdAverage = "";
    let str = "";
    let ti = "";
    if (props.device1 != null && props.device1.ptProtectiveFunction != null && props.device1.ptProtectiveFunction.stR1Year != null) {
        const ptProtectiveFunction = props.device1.ptProtectiveFunction;
        tagName = displayName(props.device1, props.device2);
        pfdAverage = `P:${ptProtectiveFunction.pfdAverage.toExponential(2)}`;
        str = `S:${ptProtectiveFunction.stR1Year.toExponential(2)}`;
        //ti = `TI:${ptProtectiveFunction.proofTestingInterval}`;
    }

    return (
        <div style={{ fontSize: props.fontSize, left: props.x, top: props.y, position: "absolute", pointerEvents: "all" }}>
            <span className="label_device">{tagName}</span>
            <span className="label_device">{pfdAverage}</span>
            <span className="label_device">{str}</span>
            {/*<span className="label_device">{ti}</span>*/}
        </div>
    );
}

export default ManualDeviceInfo;